import Markup from "../../../../markup";
import React, {useContext} from "react";
import BuilderContext from "../../../../builder/hooks/context";
import {useMediaQuery} from "react-responsive";
import {device} from "../../../../const/device";
import * as ImageFile from "../../../Global/ImageFile";

function Image() {
    const { builder } = useContext(BuilderContext);
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });
    const isMobile = useMediaQuery({ query: `(${device.mobileL})` });
    const isTabletS = useMediaQuery({ query: `(${device.tabletS})` });

    return (
        <>
            <Markup.Screen.Logos.TeamWrapper>
                <ImageFile.BaseImageFile hasPreview={isTablet && !isMobile && !isTabletS} image={builder.imagesData.image.image} loading={builder.imagesData.image?.loading} name={builder.imagesData.image.id} setImage={builder.imagesData.updateImage} />
            </Markup.Screen.Logos.TeamWrapper>

            <Markup.Screen.Logos.NoticeMessage>
                Have your artwork in vector format? You can upload SVG files directly into the builder for the best print quality.
            </Markup.Screen.Logos.NoticeMessage>
        </>
    );
}

export default React.memo(Image);